module.exports = __webpack_public_path__ + "static/img/22.49e93d2.png";


//////////////////
// WEBPACK FOOTER
// ./img/kw/22.png
// module id = NqLl
// module chunks = 1